import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyCheckAlt, faCalendarAlt, faBox } from '@fortawesome/free-solid-svg-icons';
import { clearFieldError } from '../../components/Invoicing/InvoiceValidationModal';
import ReportingMonthInput from '../../components/Invoicing/ReportingMonthInput';
import SearchableSelect from '../../components/Invoicing/SearchableSelect';
import InvoiceNotesField from '../../components/Invoicing/InvoiceNotesField';
import './OutgoingInvoice.css';
import { costCentreLabel } from '../../utils/costCentreLabel';

/**
 * Screen 3: Cost Centre & Notes for PURCHASE ORDERS
 * 
 * Fields:
 * - Cost Centre (dropdown from accounting)
 * - Purchase Order Notes (multi-line text - internal use only)
 * - Reporting Month (calendar month-year)
 * - Save Draft / Submit for Approval buttons
 * 
 * Note: NO Bank Account Details section for purchase orders
 */

const PurchaseOrderScreen3 = ({ 
  poData, 
  setPoData,
  lineItems,
  vesselInfo,
  onPrevious,
  isReadOnly = false
}) => {
  const costCenterParams = poData.hms_entity ? { entity: poData.hms_entity } : {};
  
  
  
  return (
    <div className="invoice-screen-content">
        <div className="invoice-form-section">
          <h2 className="section-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>
              <FontAwesomeIcon icon={faMoneyCheckAlt} /> Cost Centre & Notes
            </span>
            <span style={{ fontSize: '0.85em', color: '#fff', fontWeight: 'normal' }}>
              {poData.po_number ? `PO #: ${poData.po_number}` : '(PO number will be generated on save)'}
            </span>
          </h2>
          
          <div className="invoice-form-grid">
            {/* Left Column - Cost Centre & Reporting Month */}
            <div className="invoice-form-column">
              {/* Cost Centre */}
              <div className="form-field">
                <label className="field-label">
                  <FontAwesomeIcon icon={faMoneyCheckAlt} /> Cost Centre
                </label>
                <SearchableSelect
                  fetchUrl="/api/invoicing/cost-centers/"
                  params={costCenterParams}
                  displayFn={costCentreLabel}
                  value={poData.cost_center || ''}
                  onChange={(id) => {
                    setPoData(prev => ({ ...prev, cost_center: id || '' }));
                    clearFieldError('cost_center_select');
                  }}
                  placeholder="Select Cost Center..."
                  disabled={isReadOnly}
                  variant="form"
                  id="cost_center_select"
                  listOnOpen
                  pageSize={50}
                />
              </div>
              
              {/* Cost Category */}
              <div className="form-field">
                <label className="field-label">
                  <FontAwesomeIcon icon={faMoneyCheckAlt} /> Cost Category
                </label>
                <SearchableSelect
                  fetchUrl="/api/invoicing/cost-categories/"
                  displayFn={(cat) => `${cat.code} - ${cat.short_name}`}
                  value={poData.cost_category || ''}
                  onChange={(id) => {
                    setPoData(prev => ({ ...prev, cost_category: id || '' }));
                    clearFieldError('cost_category_select');
                  }}
                  placeholder="Select Cost Category..."
                  disabled={isReadOnly}
                  variant="form"
                  id="cost_category_select"
                  listOnOpen
                  pageSize={50}
                />
              </div>
              
              {/* Reporting Month */}
              <div className="form-field">
                <label className="field-label required">
                  <FontAwesomeIcon icon={faCalendarAlt} /> Reporting Month
                </label>
                {isReadOnly ? (
                  <div className="form-display-value">
                    {poData.reporting_month || 'N/A'}
                  </div>
                ) : (
                  <ReportingMonthInput
                    id="reporting_month_input"
                    className="form-input"
                    value={poData.reporting_month || ''}
                    entityId={poData.hms_entity}
                    onChange={(value) => {
                      setPoData(prev => ({ ...prev, reporting_month: value }));
                    }}
                    onClear={() => clearFieldError('reporting_month_input')}
                  />
                )}
              </div>
            </div>
            
            {/* Right Column - Notes Full Height */}
            <div className="invoice-form-column">
              {/* Internal notes only - purchase orders have no "visible on the
                  printout" tick, so no visibility props here. */}
              <InvoiceNotesField
                id="po_notes"
                label="Purchase Order Notes"
                value={poData.notes}
                onChange={(e) => setPoData(prev => ({ ...prev, notes: e.target.value }))}
                placeholder="Enter purchase order notes (internal use only)..."
                isReadOnly={isReadOnly}
                fillHeight
              />
            </div>
          </div>
          
          {/* Navigation - Only Previous button (Save/Submit are at page top) */}
          <div className="invoice-workflow-buttons">
            <button 
              type="button" 
              className="btn-secondary" 
              onClick={onPrevious}
            >
              <FontAwesomeIcon icon={faBox} /> Previous: Products
            </button>
          </div>
        </div>
      </div>
  );
};

export default PurchaseOrderScreen3;
